import { useState, useRef, useEffect } from "react";
import { classNames } from "../../helpers/classNames";

export default function Pagination({
  pageCount = 1,
  onPageChange = () => { },
  currentPage = 0,
  paginationClasses,
}) {
  const isFirst = currentPage === 0;
  const isLast = currentPage === pageCount - 1;

  const [inputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState(currentPage + 1);
  const inputRef = useRef(null);

  useEffect(() => {
    if (!inputVisible) {
      setInputValue(currentPage + 1);
    }
  }, [currentPage, inputVisible]);

  useEffect(() => {
    if (inputVisible && inputRef.current) {
      inputRef.current.focus();
    }
  }, [inputVisible]);

  const goToPage = (page) => {
    if (page >= 0 && page < pageCount) {
      onPageChange({ selected: page });
    }
  };

  const handleEnter = (e) => {
    if (e.key === "Enter") {
      handlePageChange();
    }
  };

  const handlePageChange = () => {
    const pageNum = parseInt(inputValue);
    if (!isNaN(pageNum) && pageNum >= 1 && pageNum <= pageCount) {
      goToPage(pageNum - 1);
    }
    setInputVisible(false);
  };

  return (
    <div
      className={classNames(
        "flex justify-center md:justify-end gap-1.5 py-1",
        paginationClasses
      )}
    >
      <button
        className="text-black bg-white shadow text-xl hover:text-denim hover:bg-blue-100 transition-all disabled:opacity-30 rounded-md  w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center"
        onClick={() => goToPage(0)}
        disabled={isFirst}
      >
        «
      </button>
      <button
        className="text-black bg-white shadow text-xl hover:text-denim hover:bg-blue-100 transition-all disabled:opacity-30 rounded-md  w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center"
        onClick={() => goToPage(currentPage - 1)}
        disabled={isFirst}
      >
        ‹
      </button>

      <div className="flex items-center gap-1 text-sm font-medium text-gray-700">
        <span>Page</span>

        <div
          onClick={() => setInputVisible(true)}
          className={classNames(
            "relative transition-all duration-300 ease-in-out w-8 lg:w-12",
            //inputVisible ? "w-14" : "w-12"
          )}
        >
          {inputVisible ? (
            <input
              ref={inputRef}
              type="number"
              className="w-full h-8 lg:h-10 px-2 text-center border border-denim/25 bg-white text-denim font-medium rounded-md !outline-none focus:ring-0 transition-all text-base shadow-sm"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={handleEnter}
              onBlur={handlePageChange}
              min={1}
              max={pageCount}
            />
          ) : (
            <div className="cursor-pointer w-full h-8 lg:h-10 px-2 border border-gray-300 bg-gray-50 text-denim rounded-md font-medium flex items-center justify-center hover:bg-blue-50 hover:border-denim/25 transition-all shadow-sm">
              {currentPage + 1}
            </div>
          )}
        </div>

        <span>of {pageCount}</span>
      </div>

      <button
        className="text-black bg-white shadow text-xl hover:text-denim hover:bg-blue-100 transition-all disabled:opacity-30 rounded-md  w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center"
        onClick={() => goToPage(currentPage + 1)}
        disabled={isLast}
      >
        ›
      </button>
      <button
        className="text-black bg-white shadow text-xl hover:text-denim hover:bg-blue-100 transition-all disabled:opacity-30 rounded-md  w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center"
        onClick={() => goToPage(pageCount - 1)}
        disabled={isLast}
      >
        »
      </button>
    </div>
  );
}
